export const localizationMauMsg = {
  pt: {
    locale: 'pt-BR',
    header: 'Relatório de consumo: MAUs e Mensagens',
    title: 'Visão detalhada do plano',
    monthPlaceholder: 'Período',
    consolidated: {
      plan: 'Detalhamento das métricas',
      middleInfo:
        '*O fechamento de um mês estará disponível em até 5 dias úteis contados do último dia desse mesmo mês.',
      planInformation: 'Plano {0} MAUs e Mensagens trafegadas',
      totalMiu: 'Total de MAUs',
      totalMsg: 'Total de Mensagens trafegadas',
      month: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Acompanhe o consumo de MAUs e Mensagens trafegadas por chatbot.',
      buttonShowAll: 'Ver mais',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MAUs',
      columnTotalMsg: 'Mensagens trafegadas',
    },
    daily: {
      title: 'Contabilização diária de MAUs e Mensagens trafegadas',
      buttonShowAll: 'Ver mais',
      subtitle: 'Abaixo estão detalhadas mais informações do contrato.',
      columnDateReference: 'Data',
      columnTotalMiu: 'MAUs',
      columnTotalMsg: 'Mensagens trafegadas',
    },
  },
  en: {
    locale: 'en-US',
    header: 'Usage report: MAUs and Messages',
    title: 'Detailed Plan Overview',
    monthPlaceholder: 'Period',
    consolidated: {
      plan: 'Metrics Breakdown',
      middleInfo: '*Monthly statements will become available within 5 business days of month end.',
      planInformation: 'Plan {0} MAU and Exchanged messages',
      totalMiu: 'Total number of MAUs',
      totalMsg: 'Total Exchanged messages',
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Track MAU and Exchanged message usage per chatbot.',
      buttonShowAll: 'See more',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MAUs',
      columnTotalMsg: 'Exchanged messages',
    },
    daily: {
      title: 'Daily MAUs and Exchanged messages count',
      buttonShowAll: 'See more',
      subtitle: 'Below are detailed more information on the contract.',
      columnDateReference: 'Date',
      columnTotalMiu: 'MAUs',
      columnTotalMsg: 'Exchanged messages',
    },
  },
  es: {
    locale: 'es-ES',
    header: 'Reporte de consumo: MAUs y Mensajes',
    title: 'Visión Detallada del Plan',
    monthPlaceholder: 'Período',
    consolidated: {
      plan: 'Detalle de las Métricas',
      middleInfo:
        '*Los estados de cuenta mensuales estarán disponibles dentro de los 5 días hábiles posteriores al final del mes.',
      planInformation: 'Plan {0} MAU y Mensajes intercambiados',
      totalMiu: 'Total de MAUs',
      totalMsg: 'Total de Mensajes intercambiados',
      month: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Sigue el uso de MAU y Mensajes intercambiados por chatbot.',
      buttonShowAll: 'Ver más',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MAUs',
      columnTotalMsg: 'Mensajes intercambiados',
    },
    daily: {
      title: 'Conteo diario de MAUs y de Mensajes intercambiados',
      buttonShowAll: 'Ver más',
      subtitle: 'A continuación se detalla más información sobre el contrato.',
      columnDateReference: 'Fecha',
      columnTotalMiu: 'MAUs',
      columnTotalMsg: 'Mensajes intercambiados',
    },
  },
};

export const localizationMeuMsg = {
  pt: {
    locale: 'pt-BR',
    header: 'Relatório de consumo: MEUs e Mensagens Ativas',
    title: 'Visão detalhada do plano',
    monthPlaceholder: 'Período',
    consolidated: {
      plan: 'Detalhamento das métricas',
      middleInfo:
        '*O fechamento de um mês estará disponível em até 5 dias úteis contados do último dia desse mesmo mês.',
      planInformation: 'Plano {0} MEUs e Mensagens ativas',
      totalMiu: 'Total de MEUs',
      totalMsg: 'Total de Mensagens ativas',
      month: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Acompanhe o consumo de MEUs e Mensagens ativas por chatbot.',
      buttonShowAll: 'Ver mais',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Mensagens ativas',
    },
    daily: {
      title: 'Contabilização diária de MEUs e Mensagens ativas',
      buttonShowAll: 'Ver mais',
      subtitle: 'Abaixo estão detalhadas mais informações do contrato.',
      columnDateReference: 'Data',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Mensagens ativas',
    },
  },
  en: {
    locale: 'en-US',
    header: 'Usage report: MEUs and Proactive Messages',
    title: 'Detailed Plan Overview',
    monthPlaceholder: 'Period',
    consolidated: {
      plan: 'Metrics Breakdown',
      middleInfo: '*Monthly statements will become available within 5 business days of month end.',
      planInformation: 'Plan {0} MEUs and Messages',
      totalMiu: 'Total number of MEUs',
      totalMsg: 'Total Proactive messages',
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Track MEU and Proactive message usage per chatbot',
      buttonShowAll: 'See more',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Proactive messages',
    },
    daily: {
      title: 'Daily MEUs and Proactive messages count',
      buttonShowAll: 'See more',
      subtitle: 'Below are detailed more information on the contract.',
      columnDateReference: 'Date',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Proactive messages',
    },
  },
  es: {
    locale: 'es-ES',
    header: 'Reporte de consumo: MEUs y Mensajes Proactivos',
    title: 'Visión Detallada del Plan',
    monthPlaceholder: 'Período',
    consolidated: {
      plan: 'Detalle de las Métricas',
      middleInfo:
        '*Los estados de cuenta mensuales estarán disponibles dentro de los 5 días hábiles posteriores al final del mes.',
      planInformation: 'Plan {0} MEUs y Mensajes',
      totalMiu: 'Total de MEUs',
      totalMsg: 'Total de Mensajes proactivos',
      month: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Sigue el uso de MEU y Mensajes proactivos por chatbot',
      buttonShowAll: 'Ver más',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Mensajes proactivos',
    },
    daily: {
      title: 'Conteo diario de MEUs y de Mensajes proactivos',
      buttonShowAll: 'Ver más',
      subtitle: 'A continuación se detalla más información sobre el contrato.',
      columnDateReference: 'Fecha',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Mensajes proactivos',
    },
  },
};

export const localizationMeu = {
  pt: {
    locale: 'pt-BR',
    header: 'Relatório de consumo: MEUs',
    title: 'Visão detalhada do plano',
    monthPlaceholder: 'Período',
    consolidated: {
      plan: 'Detalhamento das métricas',
      middleInfo:
        '*O fechamento de um mês estará disponível em até 5 dias úteis contados do último dia desse mesmo mês.',
      planInformation: 'Plano {0} MEUs',
      totalMiu: 'Total de MEUs',
      totalMsg: 'Total de Mensagens ativas',
      month: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Acompanhe o consumo de MEUs e Mensagens ativas por chatbot.',
      buttonShowAll: 'Ver mais',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Mensagens Ativas',
    },
    daily: {
      title: 'Contabilização diária de MEUs e Mensagens ativas',
      buttonShowAll: 'Ver mais',
      subtitle: 'Abaixo estão detalhadas mais informações do contrato.',
      columnDateReference: 'Data',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Mensagens Ativas',
    },
  },
  en: {
    locale: 'en-US',
    header: 'Usage report: MEUs',
    title: 'Detailed Plan Overview',
    monthPlaceholder: 'Period',
    consolidated: {
      plan: 'Metrics Breakdown',
      middleInfo: '*Monthly statements will become available within 5 business days of month end.',
      planInformation: 'Plan {0} MEU and Proactive Messages',
      totalMiu: 'Total number of MEUs',
      totalMsg: 'Total Proactive messages',
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Track MEU and Proactive message usage per chatbot.',
      buttonShowAll: 'See more',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Proactive Messages',
    },
    daily: {
      title: 'Daily MEUs and Proactive messages count',
      buttonShowAll: 'See more',
      subtitle: 'Below are detailed more information on the contract.',
      columnDateReference: 'Data',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Proactive Messages',
    },
  },
  es: {
    locale: 'es-ES',
    header: 'Reporte de consumo: MEUs',
    title: 'Visión Detallada del Plan',
    monthPlaceholder: 'Período',
    consolidated: {
      plan: 'Detalle de las Métricas',
      middleInfo:
        '*Los estados de cuenta mensuales estarán disponibles dentro de los 5 días hábiles posteriores al final del mes.',
      planInformation: 'Plan {0} MEUs',
      totalMiu: 'Total de MEUs',
      totalMsg: 'Total de Mensajes proactivos',
      month: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Sigue el uso de MEU y Mensajes proactivos por chatbot',
      buttonShowAll: 'Ver más',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Mensajes proactivos',
    },
    daily: {
      title: 'Conteo diario de MEUs y de Mensajes proactivos',
      buttonShowAll: 'Ver más',
      subtitle: 'A continuación se detalla más información sobre el contrato.',
      columnDateReference: 'Fecha',
      columnTotalMiu: 'MEUs',
      columnTotalMsg: 'Mensajes proactivos',
    },
  },
};

export const localizationMau = {
  pt: {
    locale: 'pt-BR',
    header: 'Relatório de consumo: MAUs',
    title: 'MAUs',
    monthPlaceholder: 'Período',
    consolidated: {
      plan: 'Plano {0}: MAUs',
      middleInfo:
        '*O fechamento de um mês estará disponível em até 5 dias úteis contados do último dia desse mesmo mês.',
      planInformation: 'Plano {0} MAUs',
      totalMiu: 'Total de MAUs',
      month: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Acompanhe o consumo de MAUs por chatbot.',
      buttonShowAll: 'Ver mais',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MAUs',
    },
    daily: {
      title: 'Contabilização diária de MAUs',
      buttonShowAll: 'Ver mais',
      subtitle: 'Abaixo estão detalhadas mais informações do contrato.',
      columnDateReference: 'Data',
      columnTotalMiu: 'MAUs',
    },
  },
  en: {
    locale: 'en-US',
    header: 'Usage report: MAUs',
    title: 'MAUs',
    monthPlaceholder: 'Period',
    consolidated: {
      plan: '{0}: MAUs',
      middleInfo: '*Monthly statements will become available within 5 business days of month end.',
      planInformation: 'Plan {0} MAUs',
      totalMiu: 'Total number of MAUs',
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Track consumption by MAUs via chatbot.',
      buttonShowAll: 'See more',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MAUs',
    },
    daily: {
      title: 'Daily accounting of MAUs',
      buttonShowAll: 'See more',
      subtitle: 'Below are detailed more information on the contract.',
      columnDateReference: 'Date',
      columnTotalMiu: 'MAUs',
    },
  },
  es: {
    locale: 'es-ES',
    header: 'Reporte de consumo: MAUs',
    title: 'MAUs',
    monthPlaceholder: 'Período',
    consolidated: {
      plan: 'Plan {0}: MAUs',
      middleInfo:
        '*Los estados de cuenta mensuales estarán disponibles dentro de los 5 días hábiles posteriores al final del mes.',
      planInformation: 'Plan {0} MAUs',
      totalMiu: 'Total de MAUs',
      month: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Seguimiento del consumo de MAU por chatbot.',
      buttonShowAll: 'Ver más',
      columnChatBot: 'ID - Chatbot',
      columnTotalMiu: 'MAUs',
    },
    daily: {
      title: 'Contabilidad diaria de MAUs',
      buttonShowAll: 'Ver más',
      subtitle: 'A continuación se detalla más información sobre el contrato.',
      columnDateReference: 'Data',
      columnTotalMiu: 'MAUs',
    },
  },
};

export const localizationMsg = {
  pt: {
    locale: 'pt-BR',
    header: 'Relatório de consumo: Mensagens',
    title: 'Mensagens',
    monthPlaceholder: 'Período',
    consolidated: {
      plan: 'Plano {0}: Mensagens',
      middleInfo:
        '*O fechamento de um mês estará disponível em até 5 dias úteis contados do último dia desse mesmo mês.',
      planInformation: 'Plano {0} Mensagens',
      totalMsg: 'Total de Mensagens',
      month: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Acompanhe o consumo de Mensagens por chatbot.',
      buttonShowAll: 'Ver mais',
      columnChatBot: 'ID - Chatbot',
      columnTotalMsg: 'Mensagens',
    },
    daily: {
      title: 'Contabilização diária de Mensagens',
      buttonShowAll: 'Ver mais',
      subtitle: 'Abaixo estão detalhadas mais informações do contrato.',
      columnDateReference: 'Data',
      columnTotalMsg: 'Mensagens',
    },
  },
  en: {
    locale: 'en-US',
    header: 'Usage report: Messages',
    title: 'Messages',
    monthPlaceholder: 'Period',
    consolidated: {
      plan: '{0}: Messages',
      middleInfo: '*Monthly statements will become available within 5 business days of month end.',
      planInformation: 'Plan {0} Messages',
      totalMsg: 'Total number of Messages',
      month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Track consumption by Messages.',
      buttonShowAll: 'See more',
      columnChatBot: 'ID - Chatbot',
      columnTotalMsg: 'Messages',
    },
    daily: {
      title: 'Daily accounting of Messages',
      buttonShowAll: 'See more',
      subtitle: 'Below are detailed more information on the contract.',
      columnDateReference: 'Date',
      columnTotalMsg: 'Messages',
    },
  },
  es: {
    locale: 'es-ES',
    header: 'Reporte de consumo: Mensajes',
    title: 'Mensajes',
    monthPlaceholder: 'Período',
    consolidated: {
      plan: 'Plan {0}: Mensajes',
      middleInfo:
        '*Los estados de cuenta mensuales estarán disponibles dentro de los 5 días hábiles posteriores al final del mes.',
      planInformation: 'Plan {0} Mensajes',
      totalMsg: 'Total de Mensajes',
      month: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
    },
    monthly: {
      title: 'Chatbots',
      subtitle: 'Seguimiento del consumo de Mensajes por chatbot.',
      buttonShowAll: 'Ver más',
      columnChatBot: 'ID - Chatbot',
      columnTotalMsg: 'Mensajes',
    },
    daily: {
      title: 'Contabilidad diaria de Mensajes',
      buttonShowAll: 'Ver más',
      subtitle: 'A continuación se detalla más información sobre el contrato.',
      columnDateReference: 'Data',
      columnTotalMsg: 'Mensajes',
    },
  },
};